import CryptoJS from 'crypto-js';

const CORRECT_KEY_HASH = "7c4deffa6094940be21db9df1d911dce14a8525c";

// This is just supposed to be a simple check that the person accessing the app has the correct key
// It's not very secure, but also, the stakes aren't really worth doing anything crazy.
// I don't have a backend to work with here and I don't want to set one up, so this'll do.
// It'll stop someone who stumbles on the app, but it won't stop someone who really wants to get in.
export function validateAppKey(key: string): boolean {
  return CryptoJS.SHA1(key).toString() === CORRECT_KEY_HASH;
}
